import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { factionIcon } from "@/lib/game";
import { FileText } from "lucide-react";

/**
 * Readable army-list popup. Wrap any trigger element as children.
 * player: { name, faction, lists: [{name, text}] }
 */
export default function ListDialog({ player, children }) {
  const lists = (player?.lists || []).filter((l) => (l.text || "").trim());
  const hasLists = lists.length > 0;

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="bg-[#0d1420] border-slate-700 max-w-4xl max-h-[88vh] overflow-hidden flex flex-col p-0" data-testid="list-dialog">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-slate-800">
          <DialogTitle className="flex items-center gap-3 text-slate-100">
            <img src={factionIcon(player?.faction)} alt="" className="h-8 w-8 object-contain"
              onError={(e) => (e.currentTarget.style.display = "none")} />
            <span>
              <span className="font-display font-black uppercase tracking-tight text-lg">{player?.name || "Player"}</span>
              <span className="block text-xs font-mono text-cyan-400/80 normal-case">{player?.faction}</span>
            </span>
          </DialogTitle>
          <DialogDescription className="sr-only">Army lists for {player?.name}</DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto px-6 py-5">
          {hasLists ? (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              {lists.map((l, i) => (
                <div key={`${l.name || "list"}-${i}`} className="rounded-xl border border-slate-800 bg-slate-900/50 overflow-hidden">
                  <div className="bg-amber-500/10 border-b border-amber-600/30 px-4 py-2.5 flex items-center gap-2">
                    <FileText className="h-4 w-4 text-amber-400" />
                    <p className="font-display font-bold text-amber-300 uppercase tracking-wide text-sm">{l.name || `List ${i + 1}`}</p>
                  </div>
                  <pre className="text-[13px] leading-relaxed text-slate-200 whitespace-pre-wrap px-4 py-4 font-mono">{l.text}</pre>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12 text-slate-500">
              <FileText className="h-10 w-10 mx-auto mb-3 text-slate-700" />
              <p className="text-sm">No army list stored for this player.</p>
              <p className="text-xs mt-1 text-slate-600">Import the event and use “Fetch lists” / “Download all lists”.</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
